<script lang="ts">
	import { preventDefault } from "svelte/legacy"

	import Logo from "../../../assets/icons/LuxedoLogo.svg"
	import { TextRowSelector } from "misc-ui"
	import LoginForm from "./LoginForm.svelte"
	import RegisterForm from "./RegisterForm.svelte"
	import { Toast } from "toaster"
	import { LuxedoRPC, RPCError } from "luxedo-rpc"
	import { navigateTo, NavigationStore } from "../../../stores/NavigationContext"
	import { pageLoader } from "../../../modules/auth/onUserLogin"
	import { onMount } from "svelte"
	import { NEXT_ROUTE_KEY, ROUTES } from "../Routes";

	const LOGIN = "Login with existing account"
	const REGISTER = "Create an account"

	let selectedOption = $state(LOGIN)
	let isLoading = $state(false)

	let firstName: string = $state()
	let lastName: string = $state()
	let email: string = $state()
	let password: string = $state()
	let passwordConfirm: string = $state()

	function failed(text: string) {
		isLoading = false
		Toast.error(text)
	}

	async function login() {
		isLoading = true

		await pageLoader.initRPC()

		if (!email) return failed("Email is required.")
		if (!password) return failed("Password is required.")

		try {
			await LuxedoRPC.api.login.login_login(email, password, "")
			postLogin()
		} catch (e) {
			console.error("Failed to log in", e)
			return failed("Invalid email or password, please try again.")
		}
	}

	async function register() {
		isLoading = true

		await pageLoader.initRPC()

		if (!email) return failed("Email is required.")
		if (!password) return failed("Password is required.")
		if (!firstName) return failed("First name is required.")
		if (!lastName) return failed("Last name is required.")
		if (password !== passwordConfirm) return failed("Passwords must match!")

		try {
			await LuxedoRPC.api.login.signup_signup(firstName, lastName, email, password, "")
			postLogin()
		} catch (e) {
			if (e instanceof RPCError) {
				if (e.statusCode === 705) return failed("CAPTCHA verification failed. Please try again.")
				if (e.statusCode === 704)
					return failed(
						"Passwords must be at least 8 characters long with at least one uppercase and one lowercase letter."
					)
				if (e.statusCode === 403) return failed("Email already in use.")
			}

			return failed("Failed to create an account at this time, please refresh and try again.")
		}
	}

	function postLogin() {

		const current = new URL(window.location.href)
		const params = new URLSearchParams(current.search)

		let next = params.get(NEXT_ROUTE_KEY) ?? "projector"

		navigateTo(next as keyof typeof ROUTES)
	}

	onMount(() => {
		NavigationStore.set(undefined)
	})
</script>

<form
	class="card-container"
	style="--card-width: {selectedOption == LOGIN ? 24 : 33}rem; --card-height: {selectedOption ==
	LOGIN
		? '34rem'
		: '36rem'}"
	onsubmit={preventDefault(selectedOption === LOGIN ? login : register)}
>
	<img id="luxedo-logo" src={Logo} alt="Luxedo Logo" />
	<TextRowSelector options={[LOGIN, REGISTER]} bind:selectedOption fontSize="var(--h3)" />

	<div class="form-container">
		{#if selectedOption == REGISTER}
			<RegisterForm bind:email bind:password bind:passwordConfirm bind:firstName bind:lastName />
		{:else}
			<LoginForm bind:email bind:password />
		{/if}
	</div>

	<!-- Just in case we get ANYONE saying they don't know how to create an account -->
	<!-- <button class="link-button">Need an account?</button> -->

	<button id="login-button" class="outline-button" type="submit" disabled={isLoading}
		>{selectedOption == LOGIN ? "Login" : "Create Account"}</button
	>
	<div class="link-footer">
		<a target="_blank" href="https://www.luxedo.com">Luxedo Store</a>
		<a target="_blank" href="https://www.luxedo.com/pages/help">Contact Us</a>
		<a target="_blank" href="https://www.luxedo.com/pages/terms-of-conditions">Terms of Service</a>
	</div>
</form>

<style>
</style>
